import React, { InputHTMLAttributes } from "react";

interface Props extends InputHTMLAttributes<HTMLSelectElement> {
  label?: string | null;
  formik: any;
  fieldName: string;
  isRequired?: boolean;
  children: React.ReactNode;
}

export default function CustomSelect({
  label,
  formik,
  fieldName,
  children,
  isRequired = false,
  ...rest
}: Props) {
  return (
    <>
      {label && (
        <label
          htmlFor={fieldName}
          className={`add-staff-label font-16 fw-bold mb-2 ${
            isRequired ? "required" : ""
          }`}
        >
          {label}
        </label>
      )}
      <select
        className={`form-select ${
          formik.errors[fieldName] && formik.touched[fieldName]
            ? "is-invalid"
            : ""
        }`}
        id={fieldName}
        {...formik.getFieldProps(fieldName)}
        type="text"
        {...rest}
      >
        {children}
      </select>
      {formik.touched[fieldName] && formik.errors[fieldName] && (
        <div className="invalid-feedback">{formik.errors[fieldName]}</div>
      )}
    </>
  );
}
